import {Transition, TransitionChild} from "@headlessui/react";
import {useState} from "react";
import {DrawerMenuContent} from "./Content";
import {Menu} from "@chayka/icons";
import {ContactFormBottomSheet} from "./ContactFormBottomSheet";

export const DrawerMenu = () => {
  const [open, setOpen] = useState(false);
  const [contactFormOpen, setContactFormOpen] = useState(false);

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    document.body.setAttribute("data-drawer-menu-open", "true");
    setOpen(true);
  };

  const handleClose = () => {
    document.body.removeAttribute("data-drawer-menu-open");
    setOpen(false);
  };

  return (
    <>
      <div className="app-drawer-menu absolute top-3 left-0 z-10">
        <button
          type="button"
          aria-label="Open navigation menu"
          onClick={handleOpen}
          className="fixed z-50 rounded-full bg-background px-2 py-3 text-blackout transition-opacity duration-500 active:opacity-50"
        >
          <Menu size={20} />
        </button>
        <Transition show={open}>
          <TransitionChild>
            <div
              className="fixed inset-0 bg-black/30 transition duration-300 data-closed:opacity-0 z-50"
              onClick={handleClose}
            />
          </TransitionChild>
          <TransitionChild>
            <div className="fixed inset-y-0 left-0 w-72 bg-background transition duration-300 data-closed:-translate-x-full z-50">
              <DrawerMenuContent onContactClick={() => setContactFormOpen(true)} />
            </div>
          </TransitionChild>
        </Transition>
      </div>
      <ContactFormBottomSheet isOpen={contactFormOpen} onClose={() => setContactFormOpen(false)} />
    </>
  );
};
